export interface SSEMessage {
  id?: string;
  event: string;
  data: string;
  retry?: number;
}

export class SSEParser {
  private buffer = '';
  private currentMessage: Partial<SSEMessage> = {};
  private currentDataLines: string[] = [];

  feed(chunk: string): SSEMessage[] {
    this.buffer += chunk;
    const messages: SSEMessage[] = [];
    const lines = this.buffer.split('\n');
    this.buffer = lines.pop() || '';

    for (const line of lines) {
      if (line === '') {
        if (this.currentDataLines.length > 0) {
          messages.push({
            id: this.currentMessage.id,
            event: this.currentMessage.event || '',
            data: this.currentDataLines.join('\n'),
            retry: this.currentMessage.retry,
          });
        }
        this.currentMessage = {};
        this.currentDataLines = [];
      } else if (line.startsWith('data: ')) {
        this.currentDataLines.push(line.slice(6));
      } else if (line.startsWith('data:')) {
        this.currentDataLines.push(line.slice(5));
      } else if (line.startsWith('event: ')) {
        this.currentMessage.event = line.slice(7);
      } else if (line.startsWith('id: ')) {
        this.currentMessage.id = line.slice(4);
      } else if (line.startsWith('retry: ')) {
        const val = parseInt(line.slice(7), 10);
        if (!isNaN(val)) {
          this.currentMessage.retry = val;
        }
      }
    }

    return messages;
  }

  flush(): SSEMessage | null {
    if (this.currentDataLines.length > 0) {
      return {
        event: this.currentMessage.event || '',
        data: this.currentDataLines.join('\n'),
        id: this.currentMessage.id,
        retry: this.currentMessage.retry,
      };
    }
    if (this.buffer.trim() !== '') {
      return { event: '', data: this.buffer };
    }
    return null;
  }

  reset(): void {
    this.buffer = '';
    this.currentMessage = {};
    this.currentDataLines = [];
  }
}
